/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Import_Summary_New_OneInputs */

const en_ui_import_summary_new_one = /** @type {(inputs: Ui_Import_Summary_New_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new session`)
};

const de_ui_import_summary_new_one = /** @type {(inputs: Ui_Import_Summary_New_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} neue Einheit`)
};

/**
* | output |
* | --- |
* | "{count} new session" |
*
* @param {Ui_Import_Summary_New_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_new_one = /** @type {((inputs: Ui_Import_Summary_New_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_New_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_new_one(inputs)
	return de_ui_import_summary_new_one(inputs)
});